/**
 * @see https://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript
 */
export const getQueryStringParams = (query: string): {} => {
  if (query) {
    const queryFormatted = /^[?#]/.test(query) ? query.slice(1) : query;

    return queryFormatted.split('&').reduce((params, param) => {
      const [key, value] = param.split('=');
      params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
      return params;
    }, {});
  }
  return {};
};
